import { render, staticRenderFns } from "./paypalAdvance.vue?vue&type=template&id=2f139211&scoped=true"
import script from "./paypalAdvance.vue?vue&type=script&lang=js"
export * from "./paypalAdvance.vue?vue&type=script&lang=js"
import style0 from "./paypalAdvance.vue?vue&type=style&index=0&id=2f139211&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f139211",
  null
  
)

export default component.exports